module.exports = __webpack_public_path__ + "img/mobile-frame.43d27b88.png";